/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright (c) 2024 Marcel Suter - Replayer
 *
 * This source code is licensed under the AGPL license found in the
 * LICENSE file in the root of this projects source tree.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

export default class Constants {
    /** A prefix for the id of an IMediaHandler implmentation */
    public static readonly HANDLER_ID_PREFIX = 'handler-';

    /** A prefix for a media element/component for a track */
    public static readonly MEDIATRACK_ID_PREFIX = 'media-track-';
}
